export default __webpack_public_path__ + "static/media/imagem_01.5f2fcf0c.png";